import React from "react";
import { ApplicationsSection } from "../Home/Applications";
import { NeedCustomGlovebox } from "../Home/NeedCustom";
import { ApplicationData } from "./ApplicationData";
import { Benefits } from "./Benefits";
import { SuccessStories } from "./SuccessStory";
import { useLocation } from "react-router-dom";

const Applications: React.FC = () => {
   const location = useLocation();
  React.useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace("#", "");
      const element:any = document.getElementById(sectionId);
      const headerOffset = 120; // pixels you want to keep above
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;
      if (element) {
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [location]);
  return (
    <div className="font-sans text-gray-800">
      {/* Page Header */}
      <section
        className="relative h-[200px] md:h-[300px] flex items-center justify-center bg-cover bg-center mt-[80px]"
        style={{
          backgroundImage: `url(${ApplicationData.hero.imgUrl})`,
        }}
      >
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/60 via-gray-900/90 to-gray-900"></div>

        <div className="relative z-10 text-center px-4 max-w-3xl">
          <h1 className="text-[#ff1a1a] font-extrabold text-3xl uppercase md:text-4xl lg:text-5xl tracking mb-2">
            {ApplicationData.hero.title}
            <span className="text-white">{ApplicationData.hero.title2}</span>
          </h1>
          <div className="w-20 h-1 bg-[#ff1a1a] mx-auto rounded-full mb-4"></div>
          <p className="text-white text-base md:text-lg font-workSans font-medium">
            {ApplicationData.hero.subTitle}
          </p>
        </div>
      </section>

      <ApplicationsSection {...ApplicationData.applicationData} />
      <Benefits {...ApplicationData.benefitsOfGloveBox} />

      <NeedCustomGlovebox {...ApplicationData.needCustom} />
      <SuccessStories {...ApplicationData.successStoriesData} />
    </div>
  );
};

export default Applications;
